import { useContext } from 'react';
import UserDeviceContext from '../contexts/UserDeviceManagment';

const useUserDeviceManagment = () => useContext(UserDeviceContext);

export default useUserDeviceManagment;
